import { login, logout, getUserBy } from "@/api/user";
import {
  getToken,
  setToken,
  removeToken,
  setUID,
  getUID,
  removeUID
} from "@/utils/auth";
import { resetRouter } from "@/router";
import Cookies from "js-cookie";

const state = {
  token: getToken(),
  uid: getUID(),
  name: "",
  fullname: "",
  role: "",
  user_company: "",
  user_project: "",
  company_name: Cookies.get("company_name") || "",
  company_uid: Cookies.get("company_uid") || "",
  user_compliancework: Cookies.get("user_compliancework") || "",
  flag_flowfund: Cookies.get("flag_flowfund") || "",
  flag_firewallsetting: Cookies.get("flag_firewallsetting") || "",
  is_whitelabel: Cookies.get("is_whitelabel") || ""
};

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token;
  },
  SET_ROLE: (state, role) => {
    state.role = role;
  },
  SET_UID: (state, token) => {
    state.uid = token;
  },
  SET_NAME: (state, name) => {
    state.name = name;
  },
  SET_FULLNAME: (state, fullname) => {
    state.fullname = fullname;
  },
  SET_USER_COMPANY_UID: (state, company_uid) => {
    state.user_company = company_uid;
    Cookies.set("user_company", company_uid);
  },
  SET_USER_PROJECT_UID: (state, project_uid) => {
    state.user_project = project_uid;
    Cookies.set("user_project", project_uid);
  },
  SET_COMPANY_NAME: (state, company_name) => {
    Cookies.set("company_name", company_name);
    state.company_name = company_name;
  },
  SET_COMPANY_UID: (state, company_uid) => {
    Cookies.set("company_uid", company_uid);
    state.company_uid = company_uid;
  },
  SET_USERCOMPLIANCEWORK: (state, user_compliancework) => {
    Cookies.set("user_compliancework", user_compliancework);
    state.user_compliancework = user_compliancework;
  },
  SET_USERFLOWFUND: (state, flag_flowfund) => {
    Cookies.set("flag_flowfund", flag_flowfund);
    state.flag_flowfund = flag_flowfund;
  },
  SET_USERFIREWALLSETTING: (state, flag_firewallsetting) => {
    Cookies.set("flag_firewallsetting", flag_firewallsetting);
    state.flag_firewallsetting = flag_firewallsetting;
  },
  SET_ISWHITELABEL: (state, is_whitelabel) => {
    Cookies.set("is_whitelabel", is_whitelabel);
    state.is_whitelabel = is_whitelabel;
  }
};

const actions = {
  // user login
  setsession({ commit }, data) {
    return new Promise((resolve, reject) => {
      if (!data.token) {
        return resolve(data);
      } else {
        commit("SET_TOKEN", data.token);
        commit("SET_UID", data.uid);
        setToken(data.token);
        setUID(data.uid);
        resolve(data);
      }
    });
  },
  login({ commit }, userInfo) {
    const { email, password, token } = userInfo;
    return new Promise((resolve, reject) => {
      login({ email: email, password: password, token: token })
        .then(res => {
          if (!res.data.token) {
            return resolve(res);
          } else {
            commit("SET_TOKEN", res.data.token);
            commit("SET_UID", res.data.uid);
            setToken(res.data.token);
            setUID(res.data.uid);
            resolve(res);
          }
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  getInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      getUserBy(state.uid)
        .then(response => {
          const { data } = response;

          if (!data) {
            reject("Verification failed, please Login again.");
          }

          const {
            role,
            uid,
            email,
            company_uid,
            project_uid,
            fullname,
            flag_compliancework,
            flag_flowfund,
            flag_firewallsetting,
            is_whitelabel
          } = data;

          commit("SET_ROLE", role);
          commit("SET_NAME", email);
          commit("SET_FULLNAME", fullname);
          commit("SET_UID", uid);
          commit("SET_USER_COMPANY_UID", company_uid);
          commit("SET_USER_PROJECT_UID", project_uid);
          commit("SET_USERCOMPLIANCEWORK", flag_compliancework);
          commit("SET_USERFLOWFUND", flag_flowfund);
          commit("SET_USERFIREWALLSETTING", flag_firewallsetting);
          commit("SET_ISWHITELABEL", is_whitelabel);

          resolve(data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  setCompany({ commit }, company) {
    return new Promise(resolve => {
      commit("SET_COMPANY_UID", company && company.uid ? company.uid : "");
      commit("SET_USER_COMPANY_UID", company && company.uid ? company.uid : "");
      commit("SET_COMPANY_NAME", company ? company.company_name : "");

      resolve();
    }).catch(error => {
      reject(error);
    });
  },

  setProject({ commit }, project) {
    return new Promise(resolve => {
      console.log(project);
      commit("SET_USER_PROJECT_UID", project ? project.uid : "");

      resolve();
    }).catch(error => {
      reject(error);
    });
  },

  // user logout
  logout({ commit, state }) {
    return new Promise(resolve => {
      logout().then(res => {
        if (res && res["result"]) {
          commit("SET_TOKEN", "");
          commit("SET_UID", "");
          commit("SET_ROLE", "");
          removeToken();
          removeUID();
          resetRouter();
          resolve();
        }
      });
    }).catch(error => {
      reject(error);
    });
  },

  // remove token
  resetToken({ commit }) {
    return new Promise(resolve => {
      commit("SET_TOKEN", "");
      commit("SET_ROLE", "");
      commit("SET_NAME", "");
      removeToken();
      removeUID();
      resolve();
    });
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
